const config={
    // oss_path:"http://172.16.210.173:9000/param/"
    // oss_path:"https://fuson-sit.clpsgroup.com.cn/param/" //uat环境地址
    oss_path:"https://t360.com.hk/param/" //uat环境地址
}
export default config